import React, { useState, useEffect } from "react";
import "../../Assets/css/ringsettings.css";
import "../../Assets/css/education.css";
import {
  Col,
  Container,
  Row,
  Form,
  Table
} from "react-bootstrap";
import { Breadcrumbs, Button, Checkbox, FormControlLabel, FormGroup, Typography,Drawer } from "@material-ui/core";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Helmet } from "react-helmet";
import Slider from "rc-slider";
import "../../../node_modules/rc-slider/assets/index.css";
import "../../../node_modules/rc-tooltip/assets/bootstrap.css";
import { NavLink, useHistory } from "react-router-dom";
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import axios from "axios";
import CloseIcon from "@material-ui/icons/Close";
import {
  base_url,
  client_name,
  currency,
  currencycode,
  isLogin,
  postHeader,
  setSteps,
  user,
} from "../../Helpers/request";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { toast } from "react-toastify";
import { isMobileOnly, isTablet } from "react-device-detect";
import { Skeleton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { cartlengthvalue } from "../../Reducer/cartReducer";
import { whishlistlength } from "../../Reducer/wishlistReducer";
import { sessionId } from "../../Reducer/homeReducer";

const { createSliderWithTooltip } = Slider;
const Range = createSliderWithTooltip(Slider.Range);

const Watches = (props) => {
  
  const history = useHistory();
  const session_Id = useSelector(state=>state.persistedReducer.home.session_id);
  const [filterdata,setFilterdata]=useState([]);
  const [productCount, setProductCount] = useState(0);
  const [view, setView] = useState(1);
  const [page, setPage] = useState(1);
  const [diamondList, setDiamondList] = useState([]);
  const [demofilterlist, setDemofilterlist] = useState([]);
  const [left, setLeft] = useState(false);


  const [addedfilter, setAddedfilter] = useState(JSON.parse(sessionStorage.getItem("bw-listfilter")) ? JSON.parse(sessionStorage.getItem("bw-listfilter")) : []);

  useEffect(()=>{
    setAddedfilter(JSON.parse(sessionStorage.getItem("bw-listfilter")) ? JSON.parse(sessionStorage.getItem("bw-listfilter")) : []);
  },[])
  const [checkFilter, setcheckFilter] = useState([]);

  const [screenWidth, setScreenWidth] = useState(window.screen.width);
  const resizeScreen = () => {
    setScreenWidth(window.innerWidth);
  };
  useEffect(() => {
resizeScreen();
    window.addEventListener("resize", resizeScreen);
    return () => {
      window.removeEventListener("resize", resizeScreen);
    };
  });
    

  const [filtercount, setFiltercount] = useState(0);

  const [filter, setFilter] = useState([]);
  const [sortbyData,setsortbyData]=useState([]);
  const [filtersuccess, setFiltersuccess] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [loader, setLoader] = useState(true);
  const [sortby, setSortby] = useState("");
  const [inputchange, setInputchange] = useState(false);
  const [clearFdata, setClearFdata] = useState(false);

  const dispatch = useDispatch();

  const clearFilter = () => {
    sessionStorage.removeItem("bw_d_filter");
    setSortby(filter?.sort_by[0]?.value);
    setClearFdata(!clearFdata);
  };

  useEffect(() => {
    onchangesdata();
  }, [sortby, inputchange, clearFdata]);

  useEffect(() => {
    diamondlistdata();
  }, [page, filtersuccess,addedfilter,sortby]);

  useEffect(()=>{
    filterApi()
  },[]);

  const onchangesdata = () => {
    setPage(1);
    var data1 = {
      sortby,
    };
    sessionStorage.setItem("bw_d_filter", JSON.stringify(data1));
    // setInterval(async () => {diamondlistdata(); }, 3000);
    // setTimeout(diamondlistdata, 2000);
    if (filtersuccess) {
      diamondlistdata();
    }
  };

  const diamondlistdata = () => {
    setLoader(true);
    setDiamondList([]);
    var data = {
      currency_code: currencycode,
      start: (page - 1) * 16,
      length: 16,
      sort_by: sortby,
      user_id: user.user_id ? user.user_id : "",
      session_id: session_Id,
      token: isLogin ? user.token : "",
      filterdata: addedfilter
    };
    axios
      .post(base_url + "/watch/watch_list", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setTotalCount(res.data.data?.count);
          setDiamondList(res.data.data?.result);
          var count = (res.data.data?.count / 16).toFixed();
          if (count * 16 >= res.data.data?.count) {
            setProductCount(count);
          } else {
            setProductCount(Number(count) + 1);
          }
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handlePageChange = (e, value) => {
    setPage(value);
    window.scrollTo(0, 0);
  };


  const addtowishlist = (product_id, wishindex) => {
    const data = {
      currency_code: currencycode,
      user_id: user.user_id ? user.user_id : "",
      session_id: session_Id,
      product_id: product_id?.stock_no,
      type: "watch",
      token: isLogin ? user.token : "",
    };
    axios
      .post(base_url + "/order/add_to_wishlist", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          const productlist = diamondList?.map((obj, index) =>
            index == wishindex
              ? Object.assign(obj, { is_wishlist: res.data.data?.wishlist_id })
              : obj
          );
          setDiamondList(productlist);
          dispatch(whishlistlength(res.data.data?.count));
        } else if (res.data.status == 2) {
          localStorage.removeItem("bw-user");
          dispatch(whishlistlength(0));
          dispatch(cartlengthvalue(0));
          dispatch(sessionId(''));
          history.push("/");
          window.location.reload(true);
        } else {
          toast.error(res.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const [expanded, setExpanded] = useState("panel0");
  const filterApi = () => {
    const data = {
      currency_code: currencycode
    };
    axios
      .post(base_url + "/watch/watch_filter", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status === 1) {
          setFilterdata(res?.data?.data?.watch_filter);
          setsortbyData(res?.data?.data?.sort_by);
          let temp=[];
          res?.data?.data?.watch_filter.forEach((e,i)=>{
         return     temp.push({
                title: e.title,
                filter: [],
                name: []
              });
          })
          setDemofilterlist(temp);
          setAddedfilter(addedfilter.length > 0 ? JSON.parse(sessionStorage.getItem("bw-listfilter")) : temp);
          
            addedfilter.forEach((e,i)=>{
              if(e.filter.length > 0){
                setFiltercount(1);
              }else{
                //setFiltercount(0);
                //sessionStorage.setItem("bw-listfilter",JSON.stringify(temp))
              }
            })
        
        
        
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handlecheckChange = (e, title, value, name) => {
    var changedata = [...addedfilter];
  if(e.target.checked){
    changedata?.forEach((val) => {
      if (val.title == title) {
        val.filter.push(value);
        val.name.push(name);
      }else{

      }
    });
    setAddedfilter(changedata);
    sessionStorage.setItem("bw-listfilter",JSON.stringify(changedata))
  }else{
    changedata.forEach((item)=>{
      if(item.title===title){
        let index= item.filter.indexOf(value);
          item.filter.splice(index,1);
          item.name.splice(index,1)
      }
    });
    setAddedfilter(changedata);
    sessionStorage.setItem("bw-listfilter",JSON.stringify(changedata))
  }
  if(changedata.length > 0){
    setFiltercount(1)
  }

  };

  const checkboxcheck = (title, value, i) => {
    var data = false;
    if(addedfilter!==null){
      if (addedfilter[i]?.title == title) {
        if (addedfilter[i]?.filter?.includes(`${value}`)) {
          data = true;
        }
      }
   }
    return data;
  };

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(panel);

  };

  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails.title}</title>
        <meta name="description" content={metaDetails.description}></meta>
        <meta name="keywords" content={metaDetails.keywords}></meta>
      </Helmet>
      <div className="rcs_ringsetting_section mt-3">
        <Container className="rcs_shap-wizard_container">
          <Row className="w-100 d-block m-auto">
            <Col xs={12} className="p-0">
              <div className="rcs_diamond_content1 mb-3">
                <h1 className="text-left text-capitalize fs30">Find Watches Easily</h1>
              </div>
            </Col>
          </Row>
          <Row className="w-100 m-auto">
          {screenWidth > 767 && 
<Col sm={3} className="pb-5 remPadLg">
  <div className="sidebarWrapper">
<div className="rcs_filter_tags">
                    {!filtercount ? (
                      ""
                    ) : (
                      <div className="rcs_filter_list">
                        <h5>
                          <span>Filtering by:</span>
                          <button 
                            onClick={() => {
                              setFiltercount(false);
                              setAddedfilter(demofilterlist);
                              sessionStorage.setItem("bw-listfilter",JSON.stringify(demofilterlist));
                              filterApi();
                             
                            }}
                            className="clear-all-filters noBtn"
                          >
                            CLEAR ALL
                          </button>
                        </h5>
                        <div className="filter_tgs_list">
                          {addedfilter?.map((val) =>
                            val.name?.map((items, index) => (
                              <>
                                <Button className="gs_filter_btn">
                                  {items}
                                  <CloseIcon
                                    onClick={(e) =>
                                      handlecheckChange(
                                        e,
                                        val.title,
                                        val.filter[index],
                                        items
                                      )
                                    }
                                    className="gs_tags_svg"
                                  />
                                </Button>
                              </>
                            ))
                          )}
                        </div>
                      </div>
                    )}
                  </div>

{filterdata?.map((val, index) => (

                    <Accordion
                   expanded={ expanded==="panel"+index
                            ? true
                            : false
                      }
                      onChange={handleChange("panel" + index)}
                      className="rcs_accordion_item noShadow watchFilters rcs_accordion"
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content"
                        id={`panel2a-header${index}`}
                        className="w-100"
                      >
                        <Typography><div className="fs16 fw600 pl-1">
                        {val.title}
                        </div> </Typography>
                      </AccordionSummary>
                      <AccordionDetails className="pb-0 pt-0">
                        <div className="rcs_price_filter">
                          <FormGroup>
                            {val?.data?.map((items) => (
                              <>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={checkboxcheck(
                                        val.title,
                                        items.value,
                                        index
                                      )}
                                      onChange={(e) =>
                                        handlecheckChange(
                                          e,
                                          val.title,
                                          items.value,
                                          items.name
                                        )
                                      }
                                    />
                                  }
                                  label={items.name}
                                />
                              </>
                            ))}
                          </FormGroup>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  ))}
</div>



</Col>
}

<div className="rcs_mobile_filter_section">
              <Drawer anchor="left" open={left} onClose={() => setLeft(false)}>
                <div className="drawerX" role="presentation" onKeyDown={() => setLeft(false)}>
                <div className="rcs_filter_tags ">
                    {!filtercount ? (
                      ""
                    ) : (
                      <div className="rcs_filter_list">
                        <h5>
                          <span>Filtering by:</span>
                          <button 
                            onClick={() => {
                              setAddedfilter(demofilterlist);
                              sessionStorage.setItem("bw-listfilter",JSON.stringify(demofilterlist));
                              filterApi();
                            }}
                            className="clear-all-filters noBtn"
                          >
                            CLEAR ALL
                          </button>
                        </h5>
                        <div className="filter_tgs_list">
                          {addedfilter?.map((val) =>
                            val.name?.map((items, index) => (
                              <>
                                <Button className="gs_filter_btn">
                                  {items}
                                  <CloseIcon
                                    onClick={(e) =>
                                      handlecheckChange(
                                        e,
                                        val.title,
                                        val.filter[index],
                                        items
                                      )
                                    }
                                    className="gs_tags_svg"
                                  />
                                </Button>
                              </>
                            ))
                          )}
                        </div>
                      </div>
                    )}
                  </div>

{filterdata?.map((val, index) => (

                    <Accordion
                   expanded={ expanded?.includes("panel" + index)
                            ? false
                            : true
                      }
                      onChange={handleChange("panel" + index)}
                      className="rcs_accordion_item noShadow watchFilters rcs_accordion"
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content"
                        id={`panel2a-header${index}`}
                        className="w-100"
                      >
                        <Typography><div className="fs16 fw600 pl-1">
                        {val.title}
                        </div> </Typography>
                      </AccordionSummary>
                      <AccordionDetails className="pb-0 pt-0">
                        <div className="rcs_price_filter">
                          <FormGroup>
                            {val?.data?.map((items) => (
                              <>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={checkboxcheck(
                                        val.title,
                                        items.value,
                                        index
                                      )}
                                      onChange={(e) =>
                                        handlecheckChange(
                                          e,
                                          val.title,
                                          items.value,
                                          items.name
                                        )
                                      }
                                    />
                                  }
                                  label={items.name}
                                />
                              </>
                            ))}
                          </FormGroup>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </div>
              </Drawer>
            </div>


            <Col
              xs={12}
              sm={9}
              className="mt-3 rcs_diamond_table p-2 mb-md-3 mb-0"
            >

<div className="rcs_view mobPb15 mb-5">
<Row className="w-100   align-items-center">
            <Col xs={4} md={6} className={view == 1 ? "" : "mb-5"}>
            {
              screenWidth < 767 &&    <div>
            <button className="noBtn" onClick={() => setLeft(true)}>Filter</button>
            </div>
            }
         
         
         {
          screenWidth > 767 &&   <div className="pt-2 pb-2 text-left">
                        {loader ? (
                          <>
                            <Skeleton
                              variant="text"
                              animation="wave"
                              className=""
                              width={150}
                              height={20}
                            />
                          </>
                        ) : (
                          <span className="pr-0"> Showing {totalCount} Results </span>
                        )}
                      </div>
         }
          
            </Col>
          </Row>
</div>

{
          screenWidth < 767 &&   <div className="pt-2 pb-2 text-center">
                        {loader ? (
                          <>
                            <Skeleton
                              variant="text"
                              animation="wave"
                              className=""
                              width={150}
                              height={20}
                            />
                          </>
                        ) : (
                          <span className="pr-0"> Showing {totalCount} Results </span>
                        )}
                      </div>
         }
          

          {view == 2 ? (
            <Row className="w-100 d-block m-auto">
              <Col xs={12} className="rcs_diamond_table p-0">
                <Table
                  hover
                  responsive
                  size="sm"
                  className="rcs_diamonds_table"
                >
                  <thead>
                    <tr>
                      <th>Shape</th>
                      <th>Carat</th>
                      <th>Color</th>
                      <th>Clarity</th>
                      <th>Cut</th>
                      <th>Lab</th>
                      <th>Price</th>
                      <th>Wishlist</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {loader ? (
                      <>
                        {[...Array(15)].map((val) => (
                          <tr>
                            <td component="th" scope="row">
                              <Skeleton
                                variant="text"
                                style={{
                                  transform: "unset",
                                  margin: "0 auto",
                                }}
                                animation="wave"
                                width={110}
                                height={30}
                              />
                            </td>
                            <td>
                              <Skeleton
                                variant="text"
                                style={{
                                  transform: "unset",
                                  margin: "0 auto",
                                }}
                                animation="wave"
                                width={110}
                                height={30}
                              />
                            </td>
                            <td>
                              <Skeleton
                                variant="text"
                                style={{
                                  transform: "unset",
                                  margin: "0 auto",
                                }}
                                animation="wave"
                                width={110}
                                height={30}
                              />
                            </td>
                            <td>
                              <Skeleton
                                variant="text"
                                style={{
                                  transform: "unset",
                                  margin: "0 auto",
                                }}
                                animation="wave"
                                width={110}
                                height={30}
                              />
                            </td>
                            <td>
                              <Skeleton
                                variant="text"
                                style={{
                                  transform: "unset",
                                  margin: "0 auto",
                                }}
                                animation="wave"
                                width={110}
                                height={30}
                              />
                            </td>
                            <td>
                              <Skeleton
                                variant="text"
                                style={{
                                  transform: "unset",
                                  margin: "0 auto",
                                }}
                                animation="wave"
                                width={110}
                                height={30}
                              />
                            </td>
                            <td>
                              <Skeleton
                                variant="text"
                                style={{
                                  transform: "unset",
                                  margin: "0 auto",
                                }}
                                animation="wave"
                                width={110}
                                height={30}
                              />
                            </td>
                            <td>
                              <Skeleton
                                variant="text"
                                style={{
                                  transform: "unset",
                                  margin: "0 auto",
                                }}
                                animation="wave"
                                width={110}
                                height={30}
                              />
                            </td>
                            <td>
                              <Skeleton
                                variant="text"
                                style={{
                                  transform: "unset",
                                  margin: "0 auto",
                                }}
                                animation="wave"
                                width={110}
                                height={30}
                              />
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      diamondList?.map((row, index) => (
                        <tr>
                          <td>{row.shape}</td>
                          <td>{row.weight}</td>
                          <td>{row.color}</td>
                          <td>{row.clarity}</td>
                          <td>{row.cut_grade}</td>
                          <td>{row.lab}</td>
                          <td style={{ fontSize: "15px", fontWeight: "600" }}>
                            {currency}
                            {row.sale_price}
                          </td>
                          
                          <td>
                            <Button
                              onClick={() =>
                                history.push(
                                  "/watch-details/" + row.stock_no
                                )
                              }
                              variant="contained"
                            >
                              Details
                            </Button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
                <Stack spacing={2} className="mt-3 mb-3 rcs_diamond_pagination">
                  <Pagination
                    count={productCount}
                    page={page}
                    onChange={handlePageChange}
                    shape="rounded"
                  />
                </Stack>
              </Col>
            </Row>
          ) : (
            <>
              <Row>
                {loader ? (
                  <>
                    {[...Array(15)].map((val) => (
                      <>
                        <Col lg={4} md={4} xs={12}>
                          <Skeleton
                            variant="text"
                            style={{
                              transform: "unset",
                              margin: "0 auto",
                              marginBottom: "15px",
                            }}
                            animation="wave"
                            height={300}
                          />
                        </Col>
                      </>
                    ))}
                  </>
                ) : (
                  diamondList.map((row, index) => (
                    <Col lg={4} md={4} xs={6} className="parentListWatch">
                      <div className="rcs_diamonds_grid_content watchList">
                        {/* <span className="rcs_diamonds_grid_info" >
                                        <img src="/static/media/inquir.9a98e4da.svg" /></span> */}
                      
                        <div className="d-flex flex-column justify-content-between h-100">
                        <NavLink className='imgWrapperWatch' to={"/watch-details/" + row.stock_no}>
                          <img src={row.imagelink} alt="diamonds" className />
                        </NavLink>

                        <div className="rcs_product_info">
                          <NavLink to={"/watch-details/" + row.stock_no}>
                          
                            <h3>{row.name}</h3>
                          </NavLink>
                          
                      
                        </div>
                        </div>
                     
                      </div>
                    </Col>
                  ))
                )}
              </Row>
              <Row className="mt-5 mb-3">
                <Col xs={12}  className="pr-0 m-auto">
                  <div className="rcs_sorting_pagi" onClick={()=>window.scrollTo(0,0)}>
                    <Stack
                      spacing={2}
                      className="mt-3 mb-3 rcs_diamond_pagination diamond_p"
                    >
                      <Pagination
                        count={productCount}
                        page={page}
                        onChange={handlePageChange}
                        shape="rounded"
                      />
                    </Stack>
                  </div>
                </Col>
              </Row>
            </>
          )}
            </Col>
          </Row>
        
        </Container>
      </div>
    </>
  );
};

export default Watches;
